module.exports = __webpack_public_path__ + "img/m-banner-ugevkzdv-zh-TW.60007055.jpg";